import React, { useState } from "react";
import { useRef } from "react";
import imgUrl from "../assets/images/imgUrl";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import pdfFile from "../assets/pdf/The_Inspiring_Journey_of_Dr. Huzaifa Khorakiwala.pdf";
import CallMadeIcon from "@mui/icons-material/CallMade";
import FloatingMenu from "../Components/FloatingMenu";

const storyData = {
  awards: [
    {
      year: "2008",
      awards: ["• BEST ROTARIAN OF THE YEAR OF ROTARY CLUB OF BOMBAY BAYVIEW"],
    },
    {
      year: "2009",
      awards: [
        "• OUTSTANDING NATIONAL CITIZEN AWARD BY NATIONAL CITIZENS GUILD",
        "• STRATHMORE’S WHO’S WHO – SOCIAL ENTREPRENEUR OF THE YEAR",
      ],
    },
    {
      year: "2010",
      awards: [
        "• AMERICARES INDIA SPIRIT OF HUMANITY AWARD FROM AMERICARES INDIA",
        "• FOUNDATION OF THE YEAR AWARD FOR OUTSTANDING CONTRIBUTIONS TO SOCIETY BY USABF (US ASIA BUSINESS FORUM)",
        "• ‘OUTSTANDING CONTRIBUTION TO TEACHING’ (PARTICULAR REFERENCE TO TEACHING HUMAN VALUES) BY HIGHER EDUCATION FORUM",
        "• PHARMA CSR ORGANIZATION OF THE YEAR 2010 AT THE ANNUAL PHARMACEUTICAL LEADERSHIP SUMMIT 2010",
        "• PHARMA CSR ORGANIZATION OF THE YEAR 2010 AT THE ANNUAL PHARMACEUTICAL LEADERSHIP SUMMIT 2010",
      ],
    },
    {
      year: "2011",
      awards: ["• IDF - CSR AWARD FROM INDIAN DEVELOPMENT FOUNDATION"],
    },
    {
      year: "2012",
      awards: [
        "• Inclusive India Award (Corporate Category) by ICICI Foundation & CNBC-TV18",
        "• CSR Visionary Leader Award at the IPE CSR Corporate Governance Awards",
      ],
    },
    {
      year: "2013",
      awards: [
        "• Rajiv Gandhi Global Excellence Award",
        "• Rajiv Gandhi Excellence Award",
        "• Bharat Gaurav Award",
        "• Corporate Social Responsibility (Health Care) Award at the Asian CSR Leadership Awards",
        "• CSR Excellence & Leadership Award for Asia Peace",
      ],
    },
    {
      year: "2015",
      awards: [
        "• Best CSR Project in Healthcare (Mobile 1000) at the Community Initiative Awards by India CSR",
        "• Best Community Development Award (Mobile 1000) at the National Awards for Excellence in CSR & Sustainability by World CSR Congress",
        "• CSR Professional of the Year at the National Awards for Excellence in CSR & Sustainability by World CSR Congress",
        "• Bronze Award for Table Calendar by A B C I (Association of Business Communicators of India)",
        "• Social Entrepreneur of the Year by Pharma Leaders",
        "• Swachh Bharat Award by Rotary International",
        "• Best Environment Friendly Project for Bio-Toilets at the Asian CSR Leadership Awards",
      ],
    },
    {
      year: "2016",
      awards: [
        "• CSR Health Impact Award (Mobile 1000) by ICICI Foundation",
        "• Lions CSR Precious Award from Lions Club International (District 323A3)",
        "• Champion of WSIS Prize Award for E-Learning Programme at Geneva Global Awards",
        "• Outstanding Leadership Award from Nurturing the Future Foundation",
        "• Peace Leader of the Year at the 7th India Leadership Conclave and Indian Affairs Business Leadership Awards",
        "• BT-CSR Excellence Award in the category of Promotion of Healthcare from Bureaucracy Today",
        "• Best Service Award for Significant National Contribution from the Institute of Technology & Science",
        "• Asia Healthcare Excellence Award for the Best CSR Practice in Healthcare by CMO Asia",
        "• CSR Community Initiative Award for Swachh Bharat Recycle Machine under the Swachh Bharat Mission category from India CSR",
        "• Author Award (Co-author for Essentials in Corporate Social Responsibility) from India CSR",
        "• India Top Awards – Excellence in India CSR Passion from International Business Federation",
        "• Peace Governor Award from World Peace & Diplomacy Organization",
        "• Best CSR in Pharma at the 9th Annual Pharmaceutical Leadership Summit & Pharma Leaders Business Leadership Awards by Network 7 Media Group",
      ],
    },
    {
      year: "2017",
      awards: [
        "• Excellence Award for Corporate Social Responsibility & Peace Mission from Indian Virtual University for Peace and Education (IVUP)",
        "• Global NGO Excellence Award for Excellence in Mother & Child Care by World CSR Day",
        "• CSR Humanity Award from India CSR",
        "• Lifetime Achievement Award from Institute of Cleanliness Education and Research (NICER)",
        "• Indian of the Year – Social Service by ILC Power Brand",
        "• The Rotary Peace Ambassador Award from Rotary",
        "• CSR Impact Award from India CSR",
        "• Magnificent Man Choice Award from Hopewill International Business Academy",
        "• Peace Ambassador of the Year from Centre of Peace Studies, Sri Lanka",
        "• Peace Ambassador for South Asia by International Association of Educators for World Peace",
        "• Greenfly Excellence Award – Social Visionary from Greenfly Entertainment",
        "• Fellow of Inner Peace & Environment from the Indian Institute of Ecology and Environment, New Delhi at the 26th World Environment Congress, New Delhi",
        "• Ambassador for Peace from All India Council of Human Rights, Liberties & Social Justice (AICHLS)",
      ],
    },
    {
      year: "2018",
      awards: [
        "• Game Changer Award from The HR Club",
        "• Sabarmati Festival Foundation Award for Outstanding Social Work from Sabarmati Festival Foundation",
        "• Divyang Ratna Award from Disable Welfare Trust of India",
        "• CEO of the Year at the Global CSR Excellence & Leadership Awards organised by World CSR Day",
        "• Amity Leadership Award from Amity Business School at the 3rd Global Leadership Research Conference",
        "• CSR Project of the Decade Award (Healthcare) from India CSR",
        "• Responsible Business Leader Award by World CSR Day at the Responsible Business Awards",
        "• CEO of the Year by Network 7 Media Group at the India Leadership Conclave",
        "• Global CSR Excellence Award by World CSR Day",
        "• Global Ambassador of Peace at the R K Excellence National Awards",
        "• Outstanding Social Contributor in Healthcare at The India Economic & Law Summit",
        "• Achiever Awards from Cinema Aajtak",
        "• Social Entrepreneur at the National Gaurav Award by Indian Bravehearts NGO",
      ],
    },
    {
      year: "2019",
      awards: [
        "• Mumbai Heroes Award from Blossom Media Pvt Ltd at the Humanity First Conclave during the World Interfaith Harmony Week",
        "• Inspiring Indian Award from Indian Ex Defence Service Employees Chamber of Commerce & Industries (IESECCI)",
        "• Award for Peace Mobilisation from Poddar Foundation at the Insure Your Mental Health Conference (Celebrating World Health Day)",
        "• Inspirational Indian of the Year at The Mumbai Achievers Awards by Mumbai Halchal",
        "• Bharat Shree Award",
        "• Rotary Award from Rotary Club of Mumbai Khar",
        "• HFF Excellence Award from Humanity First Foundation",
      ],
    },
    {
      year: "2020",
      awards: [
        "• For the Sake of Honour Award from Rotary",
        "• Excellence in Human Welfare Award from Charity with a Twist, Nargis Dutt Foundation, ECOMO",
        "• Award of Appreciation for his contribution in the fight against COVID-19 from Bhartiya Vikas Sansthan",
      ],
    },
    {
      year: "2021",
      awards: [
        "• Community Contribution Award from Kotak Life",
        "• Alpha Men Award from Mehnaaz A G Nadiadwala Foundation",
        "• Blissful India Excellence Award from Blissful India Social Welfare Trust",
        "• Maharashtra Jan Gaurav Puraskar from Sapna Subodh Saoji Charitable Trust",
        "• Entrepreneur of Country at the Dr. APJ Abdul Kalam Awards from Dr. APJ Abdul Kalam Global Foundation",
        "• Perfect Achievers Award from Perfect Woman Magazine",
        "• CSR Leader of the Decade by India CSR",
      ],
    },
    {
      year: "2022",
      awards: [
        "• Roshan Sitare Social Worker of the Year",
        "• Seva Ratna Award from St Mother Theresa University",
        "• Top 10 CEOs of the Year 2021-22 by The Indian Alert",
        "• Companion of Ambedkarite Movement",
        "• Ambassador of Humanity Award from Friends for Good Health",
        "• CSR Leader of 2021 by Blossom Media",
        "• Samaj Ratna of the Year Award from Doctor 365 at the 18th R K Excellence National Awards",
        "• Most Responsible Business Leader of the Year at the Responsible Business Awards by World CSR Day",
        "• Best CSR Initiative in Healthcare at the Healthcare Pride & Honour Awards",
        "• Atal Samman Award from Aryan M Film Production",
      ],
    },
    {
      year: "2023",
      awards: ["• Global Icon Awardee from The Global Economic Forum Summit"],
    },
    {
      year: "2024",
      awards: [
        "• Maharashtra Jan Gaurav Puraskar from Sapna Subodh Saoji Charitable Trust",
      ],
    },
    {
      year: "2025",
      awards: [
        "• Global Peace Movement Champion from Professional Speakers Association of India",
        "• Health & Humanity Impact Award at the Good Air Awards by IHW Council (Wockhardt Foundation)",
        "• Asia’s Champion Peacekeeper Award at the Asia’s Golden Icon Awards – Manila, Philippines",
      ],
    },
  ],
  doctrates: [
    {
      year: "2011",
      awards: [
        "• Doctorate of Philosophy (Honoris Causa) from International Open University",
      ],
    },
    {
      year: "2016",
      awards: [
        "• Honorary Doctorate from Indian Virtual University for Peace and Education for his contribution to society",
        "• Doctor of Philosophy (Honoris Causa) in Philanthropy from Commonwealth Vocational University, Kingdom of Tonga",
      ],
    },
    {
      year: "2017",
      awards: [
        "• Honorary Doctorate in Social Services from International University of America (IUA), London",
        "• Doctor of Philosophy (Honoris Causa) – World Peace from Young Scientists University",
        "• Doctor of Humanities from International Open University of Humanity Health Science & Peace",
        "• Doctor of Peace Education (Honoris Causa) from The Global Open University for World Peace",
        "• Doctorate of Philosophy (D.Phil) (Honoris Causa) from Amity University",
      ],
    },
    {
      year: "2018",
      awards: [
        "• Doctorate in Social Services from National Virtual University for Peace and Education",
        "• Doctor of Excellence (Honoris Causa) – Peace & Humanity from University of Entrepreneurship & Technology",
        "• Honorary Doctorate in Social Services from St Mother Teresa Virtual University for Peace and Education",
      ],
    },
    {
      year: "2019",
      awards: [
        "• Honoris Causa Degree of Doctorate in Leadership & Human Values from Desh Bhagat University",
        "• Doctor of Excellence (Honoris Causa) from European Digital University, Dubai",
      ],
    },
    {
      year: "2022",
      awards: [
        "• Honorary Degree of Doctor of Philosophy (Honoris Causa) from Poornima University",
      ],
    },
    {
      year: "2023",
      awards: [
        "• Honorary Degree – Doctor of Social Work from Mandsaur University",
      ],
    },
  ],
  dlitt: [
    {
      year: "2016",
      awards: [
        "• D.Litt (Doctor of Letters) from CIAC Global in affiliation with KEISIE International University, South Korea",
      ],
    },
    {
      year: "2019",
      awards: [
        "• Honorary Doctorate (Honoris Causa) in Literature – D.Litt from St Mother Teresa Virtual University for Peace and Education",
      ],
    },
  ],
  knighthood: [
    {
      year: "2016",
      awards: [
        "• Knighthood (Ecumenical Medical-Humanitarian Order) from Knights of St John of Jerusalem (Knights of Charity)",
      ],
    },
  ],
  manoftheyear: [
    {
      year: "2017",
      awards: [
        "• Diamond Man of the Year at the 13th R K Excellence National Awards 2017 by R K HIV AIDS Research & Care Centre",
      ],
    },
    {
      year: "2025",
      awards: [
        "• Man of the Year 2025 awarded by Prince Mario-Max Schaumburg-Lippe",
      ],
    },
  ],
  professorship: [
    {
      year: "",
      awards: [
        "• Professor in Peace Studies from Technological University of the Americas (TUA)",
      ],
    },
  ],
  princehood: [
    {
      year: "",
      awards: [
        "• Princehood Royal Title – “His Highness” from Kepangeranan Chandrarupanto Patani Shri Tiworo Principality",
      ],
    },
  ],
};

function Awards() {
  const [info, setInfo] = useState("awards");

  const sectionRef = useRef(null);
  const awardsRef = useRef(null);

  const handleScroll = () => {
    // let ref = `${refContent}Ref`;
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChildData = (data) => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    setInfo(data);
  };

  return (
    <>
      <div className="homeMainWrapper biographyWrapper awardsWrapper">
        <div className="homeBackground">
          <div className="upperImage">
            <img src={imgUrl.smileLogo} alt="smile logo"></img>
          </div>
        </div>

        <section>
          <div className="dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
            <div className="coloredBoxes">
              <div className="blueBox"></div>
              <div className="purpleBox"></div>
              <div className="blackBox"></div>
              <div className="greyBox"></div>
              <div className="pinkBox"></div>
            </div>

            <div className="iconBackground">
              <img src={imgUrl.trophy} alt="icon"></img>
            </div>

            <Typography className="headings sectionHeading blackTitles lifeStorytitle">
              Awards & Honours
            </Typography>

            <Typography className="sectionHeading blackTitles detailedPersonalinfo">
              <b> Dr. Huzaifa Khorakiwala </b> has been honoured with{" "}
              <b> 110 prestigious awards </b>
              (and counting) in recognition of his contributions to society.
              This comprehensive list of accolades spans local, national and
              international honours, reflecting the wide impact of his work in
              peace advocacy, social development and corporate leadership. His
              awards come from diverse bodies –{" "}
              <b> governments, NGOs, media, academia and royalty </b> – each
              celebrating a facet of his achievements.
            </Typography>

            <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px ">
              Notably, <b> Dr. Khorakiwala </b>received a{" "}
              <b> Knighthood in 2016, </b> bestowed by the Ecumenical
              Medical-Humanitarian Order Knights of St. John of Jerusalem
              (Knights of Charity), for his exemplary humanitarian service. He
              was also named <b> Man of the Year 2025, </b> a distinguished
              title conferred by <b> Prince Mario-Max Schaumburg-Lippe </b>(a
              European royal, author and philanthropist) to honour{" "}
              <b> Dr. Khorakiwala’s </b> extraordinary impact in that year. In
              addition, he has been conferred{" "}
              <b> 15 Honorary Doctorate degrees </b> and{" "}
              <b> 2 Doctor of Letters (D.Litt.) degrees </b> by various esteemed
              universities, recognising his thought leadership and philanthropic
              accomplishments in fields as varied as social service, peace
              studies and healthcare.
            </Typography>

            <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px ">
              Below is a chronologically sorted list of{" "}
              <b> Dr. Khorakiwala’s </b> awards. For ease of navigation, they
              are organised by year (from earliest to latest). This catalogue
              not only highlights his personal milestones but also the accolades
              earned by the institutions and movements he leads, underlining a
              legacy of excellence and compassion:
            </Typography>

            <div className="goldenTrophy mt-30px">
              <Typography className="headings sectionHeading centreText">
                Awards <br />
                & <br />
                Honours
              </Typography>
              <img src={imgUrl.goldenAward} alt="award"></img>
            </div>

            <Grid container spacing={3} className="awardSections">
              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "awards"
                      ? "iconBackground firstCircle"
                      : "iconBackground"
                  }
                  onClick={() => {
                    setInfo("awards");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.award} alt="award"></img>
                  <div className="clickTab">
                    <Typography className="pinkColortext">AWARDS</Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "awards" ? (
                    <img src={imgUrl.tapIcon} className="tapSectionimg"></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "doctrates"
                      ? "iconBackground alternatePinkbg secondCircle"
                      : "iconBackground alternatePinkbg"
                  }
                  onClick={() => {
                    setInfo("doctrates");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.doctrate} alt="doctrate"></img>
                  <div className="clickTab">
                    <Typography className="whiteText">DOCTORATES</Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "doctrates" ? (
                    <img
                      src={imgUrl.tapIconwhite}
                      className="tapSectionimg"
                    ></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "dlitt"
                      ? "iconBackground firstCircle"
                      : "iconBackground"
                  }
                  onClick={() => {
                    setInfo("dlitt");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.dlitt} alt="D.Litt"></img>
                  <div className="clickTab">
                    <Typography className="pinkColortext">D.LITT.</Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "dlitt" ? (
                    <img src={imgUrl.tapIcon} className="tapSectionimg"></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "professorship"
                      ? "iconBackground alternatePinkbg secondCircle"
                      : "iconBackground alternatePinkbg"
                  }
                  onClick={() => {
                    setInfo("professorship");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.professorship} alt="icon"></img>
                  <div className="clickTab">
                    <Typography className="whiteText">
                      PROFESSORSHIPS
                    </Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "professorship" ? (
                    <img
                      src={imgUrl.tapIconwhite}
                      className="tapSectionimg"
                    ></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              className="awardSections secondLineawards mt-20px"
            >
              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "knighthood"
                      ? "iconBackground firstCircle"
                      : "iconBackground"
                  }
                  onClick={() => {
                    setInfo("knighthood");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.knighthood} alt="knighthood"></img>
                  <div className="clickTab">
                    <Typography className="pinkColortext">
                      KNIGHTHOODS
                    </Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "knighthood" ? (
                    <img src={imgUrl.tapIcon} className="tapSectionimg"></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "princehood"
                      ? "iconBackground alternatePinkbg secondCircle"
                      : "iconBackground alternatePinkbg"
                  }
                  onClick={() => {
                    setInfo("princehood");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.princehood} alt="princehood"></img>
                  <div className="clickTab">
                    <Typography className="whiteText">PRINCEHOODS</Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "princehood" ? (
                    <img
                      src={imgUrl.tapIconwhite}
                      className="tapSectionimg"
                    ></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 3, md: 3, lg: 3 }}
                className=" d-flex-align-center-justify-center flex-direction-column "
              >
                <div
                  className={
                    info == "manoftheyear"
                      ? "iconBackground firstCircle"
                      : "iconBackground"
                  }
                  onClick={() => {
                    setInfo("manoftheyear");
                    handleScroll();
                  }}
                >
                  <img src={imgUrl.manOftheYear} alt="manOftheYear"></img>
                  <div className="clickTab">
                    <Typography className="pinkColortext">
                      MAN OF THE YEAR
                    </Typography>
                    <CallMadeIcon />
                  </div>
                  {info == "manoftheyear" ? (
                    <img src={imgUrl.tapIcon} className="tapSectionimg"></img>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </section>

        {/* award story section */}

        <section ref={sectionRef}>
          <div className="whiteSection lifeStoryWrapper awardStorywrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
            <div className="coloredBoxes">
              <div className="blueBox"></div>
              <div className="purpleBox"></div>
              <div className="blackBox"></div>
              <div className="greyBox"></div>
              <div className="pinkBox"></div>
            </div>

            <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px">
              Each award tells a story of dedication – from community service
              and corporate social responsibility to global peace leadership.
              Together, these honours paint a portrait of{" "}
              <b> Dr. Khorakiwala’s </b> enduring impact on society
            </Typography>

            <div className="coloredBoxes mt-50px">
              <div className="blueBox"></div>
              <div className="purpleBox"></div>
              <div className="blackBox"></div>
              <div className="greyBox"></div>
              <div className="pinkBox"></div>
            </div>

            <div className="accoladesMain">
              <div className="accoladesText">
                <Typography className="whiteColortext">
                  110+ PRESTIGIOUS <br />
                  ACCOLADES & <br />
                  RECOGNITIONS
                </Typography>
              </div>

              <div className="iconBackground iconYellowbg">
                <img src={imgUrl.award} alt="icon"></img>
              </div>

              <div className="accoladesText">
                <Typography className="whiteColortext">
                  THE INSPIRING JOURNEY <br />
                  OF DR. HUZAIFA <br />
                  KHORAKIWALA
                </Typography>
              </div>
            </div>

            <div className="knowMorediv upperLinkdiv mb-30px">
              <Typography className="whiteColortext">
                {info == "awards"
                  ? "AWARDS-93"
                  : info == "doctrates"
                  ? "DOCTRATES – 15"
                  : info == "dlitt"
                  ? "D.LITTS – 2 "
                  : info == "knighthood"
                  ? "KNIGHTHOOD - 1"
                  : info == "manoftheyear"
                  ? "MAN OF THE YEAR – 2"
                  : info == "professorship"
                  ? "Professorship - 1"
                  : info == "princehood"
                  ? "Princehood - 1"
                  : ""}
              </Typography>
            </div>

            {/* yearly Award story portion */}

            <div className="yearlyAwardstory">
              {storyData[info] &&
                storyData[info].map((story, index) => (
                  <div
                    className={`completeStory ${index !== 0 ? "mt-20px" : ""}`}
                    key={story.year}
                  >
                    <div
                      className={
                        info == "professorship" || info == "princehood"
                          ? "yearBgNone"
                          : "yearBg"
                      }
                    >
                      <Typography className="whiteColortext">
                        {story.year}
                      </Typography>
                    </div>
                    <div
                      className={`yearDescription ${
                        info === "professorship" || info === "princehood"
                          ? "specialYearDescription"
                          : ""
                      }`}
                    >
                      <Typography className="sectionHeading blackTitles detailedPersonalinfo bulletPoints">
                        {story.awards.map((award, idx) => (
                          <span key={idx}>
                            {award}
                            {idx !== story.awards.length - 1 && <br />}
                          </span>
                        ))}
                      </Typography>
                    </div>
                  </div>
                ))}

              <div className="upperKnowdiv">
                {/* <div className='knowMorediv mt-20px'>
                    <a href={pdfFile} rel="noopener noreferrer" download="The Inspiring Journey of Dr. Huzaifa Khorakiwala - 110 Prestigious Accolades & Recognitions.pdf">
                        <Typography className='whiteColortext'>
                        TO KNOW MORE...
                        </Typography>
                    </a>
                    </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>

      <FloatingMenu onSendData={handleChildData} />
    </>
  );
}

export default Awards;
